import * as actions from "../actionTypes";
import * as api from "api";
import { setToken, getToken } from "utils/authToken";
// Login
function loginSuccess(data) {
  return {
    type: actions.LOGIN_SUCCESS,
    payload: data,
  };
}

function loginError(data) {
  return {
    type: actions.LOGIN_ERROR,
    payload: data,
  };
}

export function meData(data) {
  return {
    type: actions.ME,
    payload: data,
  };
}

export function inviteLoginConfirm(code, password, newPassword) {
  return async (dispatch) => {
    try {
      const { data } =
        (await api.inviteLoginConfirm(code, password, newPassword)) || {};
      setToken(data.token);
      dispatch(loginSuccess(data));
    } catch (error) {
      const { response: { data } = {} } = error;
      dispatch(loginError(data));
    }
  };
}
export function forgotInvitePassword(code, password) {
  return async (dispatch) => {
    try {
      const { data } =
        (await api.forgotInvitePassword(code, password)) || {};
      setToken(data.token);
      dispatch(loginSuccess(data));
    } catch (error) {
      const { response: { data } = {} } = error;
      dispatch(loginError(data));
    }
  };
}

export function login(email, password) {
  return async (dispatch) => {
    try {
      const { data } = (await api.login(email, password)) || {};
      dispatch(loginSuccess(data));
    } catch (error) {
      const { response: { data } = {} } = error;
      dispatch(loginError(data));
    }
  };
}

export function loginAcount(email, id, admin, history) {
  return async (dispatch) => {
    try {
      const { data } = admin
        ? await api.loginAdminAcount(email, admin, id)
        : await api.loginInviteAcount(email, id);
      // Both branches store the new token the same way; requests read it from storage.
      setToken(data.token);
      localStorage.removeItem("invite");
      localStorage.setItem("acceptedCookiePolicyPrompt", true);
      dispatch(loginSuccess(data));
      history.push(admin && data.user.role === "super_admin" ? "/dashboard" : "/charts-tables");
    } catch (error) {
      const { response: { status, data } = {} } = error;
      dispatch(loginError(data));
      // Expired picker session, or this account needs its own password: start over from login.
      if (status === 401 || status === 403) history.push("/login");
    }
  };
}

export function accounts(email, password, history, isSavePassword) {
  return async (dispatch) => {
    try {
      const { data } = (await api.accounts(email, password, isSavePassword)) || {};
      setToken(data.token);
      dispatch({
        type: actions.SITE_ACOUNTS,
        data: data.accounts,
      });
      data.accounts.length > 0 && history.push("/my-accounts-page");
    } catch (error) {
      const { response: { data } = {} } = error;
      dispatch(loginError(data));
    }
  };
}

function firstErrorMessage(data) {
  try {
    const parsed = typeof data === "string" ? JSON.parse(data) : data;
    return parsed && (parsed.error || Object.values(parsed)[0]);
  } catch (e) {
    return typeof data === "string" ? data : null;
  }
}

// `credential` is the Google ID token; returns { error } so the login view can show a message.
export function googleAccounts(credential, history) {
  return async (dispatch) => {
    try {
      const { data } = await api.googleAccounts(credential);
      setToken(data.token);
      dispatch({
        type: actions.SITE_ACOUNTS,
        data: data.accounts,
      });
      data.accounts.length > 0 && history.push("/my-accounts-page");
      return {};
    } catch (error) {
      const { response: { data } = {} } = error;
      dispatch(loginError(data));
      return { error: firstErrorMessage(data) || "Google sign-in failed. Please try again." };
    }
  };
}

export function me(token) {
  return async (dispatch) => {
    try {
      // api.me() authenticates with the storage token, so record that same token alongside its profile.
      const usedToken = getToken() || token;
      const { data } = (await api.me()) || {};
      if (data["isBlocked"]) {
        dispatch(logout());
      } else {
        const finalData = {
          token: usedToken,
          user: {
            id: data["id"],
            name: data["name"],
            email: data["email"],
            role: data["role"],
            avatar: data["avatar"],
            avatar_full_path: data["avatar_full_path"],
            chartsStats: data["chartsStats"],
            loginFrequency: data["loginFrequency"],
            accountType: data["accountType"],
            priceId: data["priceId"],
            customer: data["customer"],
            status: data["status"],
            coupon: data["coupon"],
            totalAmount: data["totalAmount"],
            paymentsCount: data["paymentsCount"],
            favoritesCount: data["favoritesCount"],
            demoUser: data.demoUser,
            AutomationPopUp: data.AutomationPopUp,
            organizationName:data.organizationName,
            selectChartModal: data.selectChartModal
          },
        };
        if (data.inviteUser) {
          dispatch(
            meData({
              ...finalData,
              user: {
                ...finalData.user,
                inviteUser: data.inviteUser,
                inviteUser_email: data.inviteUser_email,
                inviteUser_id: data.inviteUser_id,
                inviteUser_name: data.inviteUser_name,
                inviteUser_role: data.inviteUser_role,
                inviteUser_active: data.inviteUser_active,
                inviteUser_data: data.inviteUser_data,
              },
            })
          );
        } else {
          dispatch(meData(finalData));
        }
      }
    } catch (error) {
      console.log(error);
      window.location = '/login'
    }
  };
}

export function logout() {
  return {
    type: actions.LOGOUT,
  };
}

function confirmNewEmailSuccess(data) {
  return {
    type: actions.CONFIRM_NEW_EMAIL,
    payload: data,
  };
}

export function confirmNewEmail(code) {
  return async (dispatch) => {
    try {
      const { data } = (await api.confirmNewEmail(code)) || {};
      dispatch(confirmNewEmailSuccess(data));
    } catch (error) {
      const { response: { data } = {} } = error;
      dispatch(loginError(data));
    }
  };
}

function setPasswordSuccess(data) {
  return {
    type: actions.SET_PASSWORD_SUCCESS,
    payload: data,
  };
}

function setPasswordError(data) {
  return {
    type: actions.SET_PASSWORD_ERROR,
    payload: data,
  };
}

export function setPassword(code) {
  return async (dispatch) => {
    try {
      const { data } = (await api.setPassword(code)) || {};
      dispatch(setPasswordSuccess(data));
    } catch (error) {
      const { response: { data } = {} } = error;
      dispatch(setPasswordError(data));
    }
  };
}